import { render, staticRenderFns } from "./PendingApprovalDesktop.vue?vue&type=template&id=0ecc76a6&scoped=true"
import script from "./PendingApprovalDesktop.vue?vue&type=script&lang=js"
export * from "./PendingApprovalDesktop.vue?vue&type=script&lang=js"
import style0 from "./PendingApprovalDesktop.vue?vue&type=style&index=0&id=0ecc76a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecc76a6",
  null
  
)

export default component.exports